export default {"src":"/_next/static/media/personal-relations.7267d5a7.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};